export const CALCULATIONS_INHERITED_BALANCE_ACCOUNTS = {
    'CALCULATIONS.INHERITED_BALANCE_ACCOUNTS.COLUMN.ACCOUNT': 'Nr. cont',
    'CALCULATIONS.INHERITED_BALANCE_ACCOUNTS.COLUMN.ACCOUNT_DESCRIPTION': 'Descriere cont',
    'CALCULATIONS.INHERITED_BALANCE_ACCOUNTS.COLUMN.INHERITED_VALUE': 'Sume preluate'
};
